import React, { useCallback, useContext } from "react";
import { SelectAsync } from "../selectAsync";
import { RequiredMarkContext } from "../../contexts/requiredMarkContext";
import { Row, Col, Form } from "react-bootstrap";
import RequiredMark from "components/requiredMark";
import Skeleton from "components/skeleton";
import { ReadOnlyInput } from "components";

import fp from "lodash/fp";

const SelectAsyncForBankRouting = ({
	input,
	meta,
	blurLoading,
	onChangeCb,
	disabled,
	hideRequiredMark, //works only with RequiredMarkContext
	readOnly,
	...props
}) => {
	const showRequiredMark =
		useContext(RequiredMarkContext) && !hideRequiredMark && !disabled;

	const checkSpanRequired = showRequiredMark && <RequiredMark />;

	const filterOption = (option, query) => {
		if (option.data.__isNew__) return true;

		return (
			option.data.value &&
			option.data.value.toLowerCase().includes(query.toLowerCase())
		);
	};

	const SelectWithError = (
		<>
			<SelectAsync
				{...props}
				onChangeCb={onChangeCb}
				filterOption={filterOption}
				debounceTimeout={300}
				cacheOptions={false}
				additional={{ page: 0 }}
				noOptionsMessage={() => "Start Typing"}
				input={input}
				meta={meta}
			/>
		</>
	);

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const SelectdWithLoader = useCallback(
		fp.cond([
			[() => blurLoading, () => <Skeleton />],
			[
				() => readOnly,
				({ input }) => (
					<ReadOnlyInput name={input.name} value={input.value} />
				),
			],
			[fp.T, ({ component }) => component],
		]),
		[blurLoading],
	);

	return (
		<Row style={{ marginBottom: 22 }}>
			<Form.Label column sm={6}>
				Routing Number{checkSpanRequired}
			</Form.Label>
			<Col sm={6}>
				<SelectdWithLoader input={input} component={SelectWithError} />
			</Col>
		</Row>
	);
};

export default SelectAsyncForBankRouting;
